<template>
  <div class="empty-list-page mt-2">


    <v-img
      class="placeholder-image"
      :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
    ></v-img>
    <v-img
      class="placeholder-image"
      :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
    ></v-img>
    <v-img
      class="placeholder-image"
      :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
    ></v-img>
    <v-img
      class="placeholder-image"
      :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
    ></v-img>
    <v-img
      class="placeholder-image"
      :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
    ></v-img>

    <div class="secondary-placeholder-section" v-show="isDesktopOrLaptop">
      <v-img
        class="placeholder-image"
        :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
        :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      ></v-img>
      <v-img
        class="placeholder-image"
        :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
        :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      ></v-img>
      <v-img
        class="placeholder-image"
        :src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
        :lazy-src="isMobile ? PlaceholderMobileImg.src : PlaceholderImg.src"
      ></v-img>
    </div>


  </div>
</template>

<script>
import PlaceholderImg from '@/assets/utility/ListPlaceholder.svg';
import PlaceholderMobileImg from '@/assets/utility/ListPlaceholderMobile.svg';

//Prefetch Image
const PlaceholderImgObj = new Image();
PlaceholderImgObj.src = PlaceholderImg;

const PlaceholderMobileImgObj = new Image();
PlaceholderMobileImgObj.src = PlaceholderMobileImg;

export default {
  data: function () {
    return {
      PlaceholderImg: PlaceholderImgObj,
      PlaceholderMobileImg: PlaceholderMobileImgObj
    };
  },
  computed:{
    isMobile: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait');
    },
    isDesktopOrLaptop: function (){
      return (this.$store.state.deviceMode === 'desktop' || this.$store.state.deviceMode === 'laptop');
    }
  },
  name: 'emptyEventsList'
};
</script>

<style scoped>
  .placeholder-image {
    border-top: 1px solid #F4f5f7;
    height: 91px;
  }
  .placeholder-image::after {
    background: linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3),hsla(0,0%,100%,0));
    -webkit-animation: loading 1.5s infinite;
    animation: loading 1.5s infinite;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }

  .placeholder-image > >>>.v-image__image{
    background-size: 100% 91px;
  }

  .secondary-placeholder-section{
    margin-top: 8px;
  }

  @-webkit-keyframes loading {
    to {
      transform:translateX(100%)
    }
  }
  @keyframes loading {
    to {
      transform:translateX(100%)
    }
  }

  @media screen and (max-width: 883px) {
    .placeholder-image {
      height: 151px;
    }

    .placeholder-image > >>>.v-image__image{
      background-size: 100% 151px;
    }
  }
</style>
